import {Dimensions, StyleSheet} from 'react-native';
import {useColorThemeType, useShadow} from '../../appStyles/hooks/theme';

import {Box} from '../../components/core/view';
import Header from '../../components/composites/Header/Header';
import {ImageParams} from '../types/common';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import React from 'react';
import {getDefaultImageUrl} from '../../utils/common';
import {CustomImage} from '@buncha/components/core/Image';

type Props = NativeStackScreenProps<any, any>;
const ImagePreview: React.FC<Props> = props => {
  const shadow = useShadow('9');
  const theme = useColorThemeType();

  const params: ImageParams = props.route.params;
  const imageUrl = params?.imageUrl?.replace('http:', 'https:') || '';

  const isMap = params?.isMap ?? false;
  const containerWidth = isMap
    ? Dimensions.get('window').width
    : Dimensions.get('window').width - 50;

  return (
    <Header showDefaultLeftHeader>
      <Box
        style={[
          styles.container,
          {width: containerWidth},
          !isMap && {
            ...shadow,
            shadowColor: theme?.shadow[100],
          },
        ]}>
        <CustomImage
          resizeMode="contain"
          source={imageUrl}
          style={styles.singleImage}
          onErrorSource={getDefaultImageUrl()}
          rotate={isMap}
        />
      </Box>
    </Header>
  );
};

export default ImagePreview;
const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignSelf: 'center',
    height: 500,
  },
  singleImage: {
    alignSelf: 'center',
    borderRadius: 10,
    width: 500,
    height: 500,
  },
});
